import { lazy, Suspense } from 'react';
import { Analytics } from '@vercel/analytics/react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Nav from './components/Nav';
import HomePage from './pages/HomePage';
import PracticesPage from './pages/PracticesPage';
import CorporatePage from './pages/pa/CorporatePage';
import LicensingPage from './pages/pa/LicensingPage';
import LabourPage from './pages/pa/LabourPage';
import PrivacyPage from './pages/pa/PrivacyPage';
import RealEstatePage from './pages/pa/RealestatePage';
import DisputesPage from './pages/pa/DisputesPage';
import ScrollToTop from './components/ScrollToTop';
import GaPageViews from './components/GaPageViews';
import DeferredRevealObserver from './components/DeferredRevealObserver';
import PageLoading from './components/PageLoading';
import RoutePrefetcher from './components/RoutePrefetcher';
import { PaLabelsProvider } from './context/PaLabelsContext';
import { TeamPhotosProvider } from './context/TeamPhotosContext';
import PageMeta from './components/PageMeta';

const TeamPage = lazy(() => import('./pages/TeamPage'));
const ToolkitsPage = lazy(() => import('./pages/ToolkitsPage'));
const UpdatesPage = lazy(() => import('./pages/UpdatesPage'));
const ArticlePage = lazy(() => import('./pages/ArticlePage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const ProfilePage = lazy(() => import('./pages/ProfilePage'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));

export default function App() {
  return (
    <TeamPhotosProvider>
      <PaLabelsProvider>
      <PageMeta />
      <ScrollToTop />
      <GaPageViews />
      <DeferredRevealObserver />
      <Nav />
      <RoutePrefetcher />
      <main id="main-content">
        <Suspense fallback={<PageLoading message="Loading…" />}>
          <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/practices" element={<PracticesPage />} />
          <Route path="/practices/corporate" element={<CorporatePage />} />
          <Route path="/practices/licensing" element={<LicensingPage />} />
          <Route path="/practices/labour" element={<LabourPage />} />
          <Route path="/practices/privacy" element={<PrivacyPage />} />
          <Route path="/practices/realestate" element={<RealEstatePage />} />
          <Route path="/practices/disputes" element={<DisputesPage />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/team/:slug" element={<ProfilePage />} />
          <Route path="/toolkits" element={<ToolkitsPage />} />
          <Route path="/updates" element={<UpdatesPage />} />
          <Route path="/updates/:id" element={<ArticlePage />} />
          <Route path="/contact" element={<ContactPage />} />
          {/* Legacy redirects */}
          <Route path="/pa-corporate" element={<Navigate to="/practices/corporate" replace />} />
          <Route path="/pa-licensing" element={<Navigate to="/practices/licensing" replace />} />
          <Route path="/pa-labour" element={<Navigate to="/practices/labour" replace />} />
          <Route path="/pa-privacy" element={<Navigate to="/practices/privacy" replace />} />
          <Route path="/pa-realestate" element={<Navigate to="/practices/realestate" replace />} />
          <Route path="/pa-disputes" element={<Navigate to="/practices/disputes" replace />} />
          <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Suspense>
      </main>
      </PaLabelsProvider>
      <Analytics />
    </TeamPhotosProvider>
  );
}
